export const MinusIcon = ({
  fillColor = '#18181B',
  width = 20,
  height = 20
}: {
  fillColor?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8125 10.0015C17.8125 10.2501 17.7137 10.4886 17.5379 10.6644C17.3621 10.8402 17.1236 10.939 16.875 10.939H3.125C2.87636 10.939 2.6379 10.8402 2.46209 10.6644C2.28627 10.4886 2.1875 10.2501 2.1875 10.0015C2.1875 9.75282 2.28627 9.51437 2.46209 9.33855C2.6379 9.16274 2.87636 9.06396 3.125 9.06396H16.875C17.1236 9.06396 17.3621 9.16274 17.5379 9.33855C17.7137 9.51437 17.8125 9.75282 17.8125 10.0015Z"
        fill={fillColor}
      />
    </svg>
  );
};

MinusIcon.displayName = 'MakroUI.MinusIcon';
